import React from "react";
import "./SocialVid.css";

const SocialVidHead = () => {
  return (
    <div className="socialVidHeadContainer">
      <h2>
        From Beginner to Bilingual: <span>German Student</span> Stories
      </h2>
    </div>
  );
};

export default SocialVidHead;
